export default __webpack_public_path__ + "static/raven-banner-2dab62f3244e871e675f6fa2c647c28d.webp";